
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function verifyFitmentRT () {
    return this.isVehicleSelected ? _createElement('li', {
        'className': 'cm_vehicle-widget cm_vehicle-widget__verify-fitment',
        'key': '0'
    }, this.fits === 'yes' ? [
        [_createElement('svg', {
                'width': '16',
                'height': '16',
                'viewBox': '0 0 16 16',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '1480'
            }, _createElement('path', {
                'd': 'M3.5 8.5L6.5 11.5L12.5 5.5',
                'fill': 'none',
                'stroke': 'green',
                'strokeWidth': '2.5',
                'strokeLinecap': 'round',
                'strokeLinejoin': 'round'
            }))],
        ' Fits your vehicle.'
    ] : null, this.fits === 'no' ? [
        [_createElement('svg', {
                'width': '16',
                'height': '16',
                'viewBox': '0 0 16 16',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '4800'
            }, _createElement('line', {
                'x1': '4',
                'y1': '4',
                'x2': '12',
                'y2': '12',
                'stroke': '#E53935',
                'strokeWdth': '2',
                'strokeLinecap': 'round'
            }), _createElement('line', {
                'x1': '12',
                'y1': '4',
                'x2': '4',
                'y2': '12',
                'stroke': '#E53935',
                'strokeWidth': '2',
                'strokeLinecap': 'round'
            }))],
        ' Doesn\'t fit your vehicle.'
    ] : null, this.fits === 'aggressive' ? [
        [_createElement('svg', {
                'width': '16',
                'height': '16',
                'viewBox': '0 0 16 16',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '8900'
            }, _createElement('circle', {
                'cx': '8',
                'cy': '8',
                'r': '4'
            }))],
        ' Vehicle modifications may be required.'
    ] : null, _createElement('a', {
        'className': 'cm_verify-fitment_change-button',
        'href': '#',
        'onClick': this.openDialog
    }, 'Change vehicle')) : null;
}
        export const componentNames = []